var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholderLineChart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 142.9 116.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #bababa;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-4 {\n        fill: #f2f2f2;\n      }\n\n      .cls-5 {\n        fill: #cfcfcf;\n      }\n\n      .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-3 {\n        stroke: #cfcfcf;\n        stroke-width: .9px;\n      }\n\n      .cls-6 {\n        fill: #d2d2d2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M83.9,42.1c-8.4,0-16.9-.3-24.8-2.5-8-2.2-15-6.4-21.4-11.2-4.2-3.2-8-5.7-13.4-5.3-5.3.3-10.4,2.3-14.5,5.7-6.9,6.1-5.9,17.3-3.1,25.1,4.2,11.9,16.8,20.1,27.6,25.5,12.4,6.2,26.1,9.8,39.8,11.9,12,1.8,27.4,3.2,37.8-4.7,9.6-7.2,12.2-23.6,9.8-34.7-.6-3.3-2.3-6.2-4.9-8.3-6.7-4.9-16.7-1.6-24.2-1.5-2.8,0-5.6.1-8.5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43,3.3v4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.9,5.4h4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M124.6,89v4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M122.4,91.1h4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M10.5,70.4c.5,0,1-.4,1-1s-.4-1-1-1-1,.4-1,1,.4,1,1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M94,7.7c.5,0,1-.4,1-1s-.4-1-1-1-1,.4-1,1,.4,1,1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M66.8,110.6c20.3,0,36.7-1,36.7-2.3s-16.4-2.3-36.7-2.3-36.7,1-36.7,2.3,16.4,2.3,36.7,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.5,14.9h53.3c1.3,0,2.6.5,3.5,1.5.9.9,1.5,2.2,1.5,3.5v63.4c0,1.3-.5,2.6-1.5,3.5-.9.9-2.2,1.5-3.5,1.5H31.7c-1.3,0-2.6-.5-3.5-1.5-.9-.9-1.5-2.2-1.5-3.5V26.9l11.8-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M96.6,45.8h-55v43.1h55v-43.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.7,26.9h9.7c.6,0,1.1-.2,1.5-.6.4-.4.6-.9.6-1.5v-9.8l-11.8,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.3,32.1h-54.4c-2.1,0-3.8,1.7-3.8,3.8v11.6c0,2.1,1.7,3.8,3.8,3.8h54.4c2.1,0,3.8-1.7,3.8-3.8v-11.6c0-2.1-1.7-3.8-3.8-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M48.7,45.1c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3-3.3,1.5-3.3,3.3,1.5,3.3,3.3,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M59.2,45.1c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3-3.3,1.5-3.3,3.3,1.5,3.3,3.3,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M69.7,45.1c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3-3.3,1.5-3.3,3.3,1.5,3.3,3.3,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.3,53.5h-54.4c-2.1,0-3.8,1.7-3.8,3.8v11.6c0,2.1,1.7,3.8,3.8,3.8h54.4c2.1,0,3.8-1.7,3.8-3.8v-11.6c0-2.1-1.7-3.8-3.8-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M48.7,66.5c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3-3.3,1.5-3.3,3.3,1.5,3.3,3.3,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M59.2,66.5c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3-3.3,1.5-3.3,3.3,1.5,3.3,3.3,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M69.7,66.5c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3-3.3,1.5-3.3,3.3,1.5,3.3,3.3,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.3,74.8h-54.4c-2.1,0-3.8,1.7-3.8,3.8v11.6c0,2.1,1.7,3.8,3.8,3.8h54.4c2.1,0,3.8-1.7,3.8-3.8v-11.6c0-2.1-1.7-3.8-3.8-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M48.7,87.9c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3-3.3,1.5-3.3,3.3,1.5,3.3,3.3,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M59.2,87.9c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3-3.3,1.5-3.3,3.3,1.5,3.3,3.3,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M69.7,87.9c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3-3.3,1.5-3.3,3.3,1.5,3.3,3.3,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.2,56.4c11.4,0,20.7-9.3,20.7-20.7s-9.3-20.7-20.7-20.7-20.7,9.3-20.7,20.7,9.3,20.7,20.7,20.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116,50.7l5.5,5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.9,53.6l-1.7,1.8c-.8.8-.7,2.1,0,2.9l14.9,14.2c.8.8,2.1.7,2.9,0l1.7-1.8c.8-.8.7-2.1,0-2.9l-14.9-14.2c-.8-.8-2.1-.7-2.9,0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderLineChart);
export default __webpack_public_path__ + "static/media/Placeholder_Line_Chart.ac3912b5b73ebe2eb98f149a70bad5e4.svg";
export { ForwardRef as ReactComponent };